import { render, staticRenderFns } from "./JoiningApplicationEducational.vue?vue&type=template&id=50d388be&"
import script from "./JoiningApplicationEducational.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationEducational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports